<template>
  <div class="row">
    <div class="col-sm-4">
      <label class="form-label" for="is-active">Prikaži aktivne</label>
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="is-active" v-model="displayActive"  />
      </div>
    </div>
    <div class="col">
      <button class="btn btn-primary" type="button" @click="$router.push({ name: 'FacilityEdit', params: { facilityId: 'new' } })">Nov objekt</button>
    </div>
  </div>


  <div class="row mt-4">
    <div class="col-md-6">
      <div class="row">
        <label class="col-form-label col-sm-3">Išči</label>
        <div class="col-sm-9">
          <div class="input-group">
            <input type="text" class="form-control" v-model="nameFilter" />
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row mt-4">
    <div class="col">
      <div class="table-responsive">
        <table class="table table-stripped table-sm table-hover">
          <thead>
            <tr>
              <th scope="col">Objekt</th>
              <th scope="col">Kraj</th>
              <th scope="col">Naslov</th>
            </tr>
          </thead>
          <tbody>
            <tr role="button" v-for="w in filteredFacilities" @click="selectFacility(w.id)">
              <td>{{ w.name }}</td>
              <td>{{ w.postCity }}</td>
              <td>{{ w.address }}</td>
            </tr>
        </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useAuth } from "../composition-api/useAuth"
import { listEntitiesAsync } from "../api"

defineOptions({ name: "Facilities" })

const route = VueRouter.useRoute()
const router = VueRouter.useRouter()

const displayActive = ref(true)
const nameFilter = ref("")

const { fetchAuthAsync } = useAuth()

const facilities = ref([])

const filteredFacilities = computed(() => {
  return facilities.value
    .filter((facility) => facility.isActive === displayActive.value)
    .filter(
      (facility) =>
        facility.name?.toLowerCase().includes(nameFilter.value.trim().toLowerCase()) ||
        facility.address?.toLowerCase().includes(nameFilter.value.trim().toLowerCase()) ||
        facility.postCity?.toLowerCase().includes(nameFilter.value.trim().toLowerCase()),
    )
})

const selectFacility = (facilityId) => router.push({ name: "FacilityEdit", params: { facilityId } })

onMounted(async () => (facilities.value = await listEntitiesAsync(fetchAuthAsync, "Facilities", "?variant=Full")))
</script>
